import { render } from "./TalentProfileComponent.vue?vue&type=template&id=f0f3bef8&scoped=true"
import script from "./TalentProfileComponent.vue?vue&type=script&lang=js"
export * from "./TalentProfileComponent.vue?vue&type=script&lang=js"

import "./TalentProfileComponent.vue?vue&type=style&index=0&id=f0f3bef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f3bef8"]])

export default __exports__